module.exports = __webpack_public_path__ + "img/block4-img.9fb2c929.svg";